import { type MutationTree } from 'vuex';

import { type IInternalContactAgreementState } from './types';

export const RECEIVE_BY_AGREEMENT = 'receiveByAgreement';

export const mutations: MutationTree<IInternalContactAgreementState> = {
    [RECEIVE_BY_AGREEMENT](_state: IInternalContactAgreementState, { agreementId, idList }: { agreementId: number; idList: number[] }) {
        _state.byAgreement.set(agreementId, idList);
    }
};
